<div class="entity-details-panel" *ngIf="markerData"
     [class.marker-identity]="markerData?.type === 'identity'"
     [class.marker-router]="markerData?.type === 'routers'"
     [class.marker-service]="markerData?.type === 'services'">
  <div class="details-section">
    <table class="details-table">
    <tr>
      <td class="popup-label">Type:</td>
      <td class="popup-value">
        {{ markerData?.type === 'identity' ? 'Identity' : markerData?.type === 'services' ? 'Service' : 'Router' }}
      </td>
    </tr>
    <tr *ngIf="markerData?.type !== 'services' && (markerData?.item?.isOnline !== undefined || markerData?.item?.connected !== undefined)">
      <td class="popup-label">Status:</td>
      <td class="popup-value">
        <span [class]="getEntityOnlineStatus(markerData?.item) ? 'status-online' : 'status-offline'">
          {{ getEntityOnlineStatus(markerData?.item) ? 'Online' : 'Offline' }}
        </span>
      </td>
    </tr>
    <tr *ngIf="markerData?.type === 'identity' && markerData?.item?.edgeRouterConnectionStatus">
      <td class="popup-label">Status:</td>
      <td class="popup-value">
        <span [class]="markerData?.item?.edgeRouterConnectionStatus === 'online' ? 'status-online' : 'status-offline'">
          {{ markerData?.item?.edgeRouterConnectionStatus === 'online' ? 'Connected' : 'Disconnected' }}
        </span>
      </td>
    </tr>
    <tr>
      <td class="popup-label">Name:</td>
      <td class="popup-value">{{ markerData?.item?.name || 'N/A' }}</td>
    </tr>
    <tr *ngIf="markerData?.item?.id">
      <td class="popup-label">ID:</td>
      <td class="popup-value popup-id">{{ markerData?.item?.id }}</td>
    </tr>
    <tr *ngIf="markerData?.location && markerData?.type !== 'services'">
      <td class="popup-label">Location:</td>
      <td class="popup-value popup-location" [class.location-modified]="hasUnsavedLocationChanges(markerData?.item)">
        {{ markerData?.location?.lat?.toFixed(4) }}, {{ markerData?.location?.lng?.toFixed(4) }}
        <span *ngIf="hasUnsavedLocationChanges(markerData?.item)" class="modified-indicator">*</span>
      </td>
    </tr>
    <tr>
      <td class="popup-label">Role Attributes:</td>
      <td class="popup-value popup-roles">
        <span *ngIf="markerData?.item?.roleAttributes && markerData?.item?.roleAttributes?.length > 0">
          <span *ngFor="let role of markerData?.item?.roleAttributes" class="popup-hashtag" (click)="onRoleAttributeClick(role)">
            #{{ role }}
          </span>
        </span>
        <span *ngIf="!markerData?.item?.roleAttributes || markerData?.item?.roleAttributes?.length === 0" class="no-attributes">
          No attributes assigned
        </span>
      </td>
    </tr>
    </table>
  </div>

  <!-- Active Services Section -->
  <div class="circuits-section" *ngIf="circuits.length > 0">
    <div class="circuits-container">
      <div class="circuits-header">
        <span class="circuits-header-icon icon-services"></span>
        <span class="circuits-header-text">Active Services ({{ serviceGroups.length }})</span>
      </div>
      <div class="circuits-list">
        <table class="circuits-table tree-table">
          <colgroup>
            <col style="width: 30px;">  <!-- Indent -->
            <col>                        <!-- Client - flexible -->
            <col>                        <!-- Host - flexible -->
            <col style="width: 120px;">  <!-- Created -->
            <col style="width: 26px;">   <!-- Action -->
          </colgroup>
          <thead>
            <tr>
              <th colspan="5" class="service-column">Service Name</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let group of serviceGroups">
              <!-- Service Group Row -->
              <tr class="group-row clickable-row" (click)="toggleGroup(group, $event)">
                <td class="expand-cell">
                  <span class="expand-icon icon-RightPage" [class.expanded]="group.expanded"></span>
                </td>
                <td colspan="4" class="service-name">
                  <span class="icon-Services group-icon"></span>
                  <span class="service-text">{{ group.serviceName }}</span>
                  <span class="circuit-count">({{ group.circuits.length }})</span>
                </td>
              </tr>

              <!-- Circuit Rows (shown when expanded) -->
              <ng-container *ngIf="group.expanded">
                <!-- Subheader Row -->
                <tr class="subheader-row">
                  <th class="subheader-indent"></th>
                  <th class="subheader-cell">Client</th>
                  <th class="subheader-cell">Host</th>
                  <th class="subheader-cell sortable-header" (click)="toggleSort(group)">
                    Created
                    <span class="sort-indicator" *ngIf="group.sortBy === 'created'">
                      {{ group.sortDirection === 'asc' ? '▲' : '▼' }}
                    </span>
                  </th>
                  <th class="subheader-cell"></th>
                </tr>

                <!-- Circuit Data Rows -->
                <tr *ngFor="let circuit of getSortedCircuits(group)"
                    (click)="onCircuitSelect(circuit, $event)"
                    [class.selected-row]="selectedCircuit?.id === circuit.id"
                    class="circuit-row clickable-row">
                  <td class="circuit-indent"></td>
                  <td class="circuit-entity">
                    <span [class]="getClientInfo(circuit).type === 'identity' ? 'icon-identity entity-icon' : 'icon-routers entity-icon'"></span>
                    <span class="entity-name">{{ getClientInfo(circuit).name }}</span>
                  </td>
                  <td class="circuit-entity">
                    <span [class]="getHostInfo(circuit).type === 'identity' ? 'icon-identity entity-icon' : 'icon-routers entity-icon'"></span>
                    <span class="entity-name">{{ getHostInfo(circuit).name }}</span>
                  </td>
                  <td class="circuit-created">
                    {{ circuit.createdAt | date:'short' }}
                  </td>
                  <td class="action-column">
                    <span class="circuit-nav-icon icon-Share-RBAC" (click)="onCircuitPreviewOpen(circuit, $event)" title="View Circuit Details"></span>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Router Path Details Section -->
  <div class="router-path-section" *ngIf="selectedCircuit && selectedCircuitRouters.length > 0">
    <div class="router-path-container">
      <div class="router-path-header">
        <span class="router-path-icon icon-routers"></span>
        <span class="router-path-text">Circuit Path ({{ selectedCircuitRouters.length }} routers)</span>
      </div>
      <div class="router-path-list">
        <table class="router-path-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Router Name</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let router of selectedCircuitRouters; let i = index"
                (click)="onRouterInPathSelect(router.id, 'routers')"
                [class.selected-row]="selectedRouterInPath === router.id"
                class="clickable-circuit-row">
              <td class="path-index">{{ i + 1 }}</td>
              <td class="router-name">{{ router.name || router.id }}</td>
              <td class="router-status">
                <span *ngIf="!router._notFound && router.connected !== undefined"
                      [class]="router.connected ? 'status-online' : 'status-offline'">
                  {{ router.connected ? 'Online' : 'Offline' }}
                </span>
                <span *ngIf="router._notFound" class="status-unknown">Unknown</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="action-section">
    <button *ngIf="hasUnsavedLocationChanges(markerData?.item)"
            class="save-location-btn"
            (click)="onSaveLocationChanges()">
      Save Changes
    </button>
    <button class="cancel-btn" (click)="onCancel()">
      Cancel
    </button>
    <button class="popup-details-btn" (click)="onNavigateToDetails()">
      Go To Edit Page
      <span class="icon-RightPage"></span>
    </button>
  </div>
</div>
